<template>
	<div class="xs-12 p4">
		<note-form @submit="handleSubmit">
			<template slot-scope="{ onSubmit }">
				<j-button :isLoading="isLoading" @click="onSubmit">
					{{ $t("save") }}
				</j-button>
			</template>
		</note-form>
	</div>
</template>

<script>
/**
 * This component is responsible for creation of note
 * We can do createEntityNote or createPolicyNote
 */
import NoteForm from "./NoteForm.vue"
import JButton from "@/components/JButton"
import api from "../../api/"

export default {
	components: { NoteForm, JButton },

	props: {
		/**
		 * Id of policy or entity we are adding note to
		 */
		id: {
			type: String,
			required: true,
			default: ""
		},
		notesOf: {
			type: String,
			required: true
		}
	},

	data: () => ({
		isLoading: false
	}),

	methods: {
		async handleSubmit(payload) {
			let apiKey = null

			// Policy
			if (this.notesOf === "policy")
				apiKey = {
					query: "addPolicyNote",
					inputKey: "noteInput",
					variable: "policyId"
				}

			// Claim
			if (this.notesOf === "claim")
				apiKey = {
					query: "addClaimNote",
					inputKey: "input",
					variable: "claimId"
				}

			// Entity
			if (this.notesOf === "individual" || this.notesOf === "company")
				apiKey = {
					query: "addEntityNote",
					inputKey: "noteInput",
					variable: "entityId"
				}

			// Case
			if (this.notesOf === "case")
				apiKey = {
					query: "addNoteToCase",
					inputKey: "input",
					variable: "caseId"
				}

			this.isLoading = true
			const res = await api[apiKey.query]({
				[apiKey.inputKey]: payload,
				[apiKey.variable]: this.id
			})
			this.isLoading = false

			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			this.$emit("note:created")
		}
	}
}
</script>